import type {
  NotificationListResponse,
  MarkNotificationsReadRequest,
} from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

export async function listNotifications(
  unreadOnly = false,
): Promise<NotificationListResponse> {
  const qs = unreadOnly ? '?unreadOnly=true' : '';
  return apiRequest<NotificationListResponse>(`/api/notifications${qs}`, {
    method: 'GET',
  });
}

export async function markNotificationsRead(
  data: MarkNotificationsReadRequest,
): Promise<void> {
  await apiRequest<void>('/api/notifications/mark-read', {
    method: 'POST',
    body: data,
  });
}
